import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import merge from 'lodash.merge';

import Wrapper from 'src/Wrapper';
import { traitPropType, stylePropType } from 'src/PropTypes';
import { Style1 } from 'src/styles';

class Gauge extends Component {
  render() {
    const { label: trait, style, value, options, onClick, title } = this.props;
    if (!trait || !value) {
      return <div>Loading</div>;
    }
    const axisLabel = {
      ...style.Gauge.axisLabel,
      formatter: (v) => {
        // if (v === 0) return `0 (${trait.lowRangeName})`;
        // if (v === 100) return `100 (${trait.highRangeName})`;
        if (v % 10 === 0) return v.toString();
        return '';
      },
    };
    const chartOption = {
      title: {
        text: title,
        ...style.global.title,
      },
      textStyle: {
        ...style.Gauge.textStyle,
      },
      label: {
        ...style.Gauge.label,
      },
      series: [
        {
          name: trait.trait,
          type: 'gauge',
          title: style.Gauge.title,
          radius: '90%',
          center: ['50%', '50%'],
          min: 0,
          max: 100,
          pointer: style.Gauge.pointer,
          itemStyle: style.Gauge.itemStyle,
          axisLabel,
          axisLine: style.Gauge.axisLine(trait.factor),
          axisTick: style.Gauge.axisTick,
          splitNumber: style.Gauge.splitNumber,
          splitLine: style.Gauge.splitLine,
          detail: style.Gauge.detail,
          data: [
            {
              value: value.toFixed(1),
              name: `${trait.lowRangeName}            ${trait.highRangeName}`,
              code: trait.code,
            },
          ],
        },
      ],
      backgroundColor: style.global.backgroundColor,
    };
    const mergedOptions = merge(chartOption, options);
    return (
      <Wrapper>
        <ReactEcharts
          ref={(element) => {
            const instance = element ? element.getEchartsInstance() : null;
            if (instance) {
              instance.off('click');
              instance.on('click', 'series', (params) => {
                onClick(params.data.code);
              });
            }
          }}
          style={{
            width: '100%',
            height: '100%',
          }}
          option={mergedOptions}
        />
      </Wrapper>
    );
  }
}

Gauge.propTypes = {
  label: traitPropType.isRequired,
  value: PropTypes.number.isRequired,
  title: PropTypes.string,
  style: stylePropType,
  options: PropTypes.shape({}),
  onClick: PropTypes.func,
};

Gauge.defaultProps = {
  title: '',
  style: Style1,
  options: {},
  onClick: () => null,
};

export default Gauge;
